import { render } from "./StaffAttendanceEdit.vue?vue&type=template&id=558d549c&ts=true"
import script from "./StaffAttendanceEdit.vue?vue&type=script&lang=ts"
export * from "./StaffAttendanceEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__